import React from 'react'

const Field = ({name, title,  type = "text", value, placeholder, handleForm, disabled = false}) => {

    return (
        <div className="connect__card__field">
            <label htmlFor={name}>{title || name}</label>
            <input 
                id={name} 
                type={type} 
                placeholder={placeholder || title || name}
                value={value}
                onChange={(e) => handleForm({name, value: e.target.value})} 
                disabled={disabled}
            />
        </div>
    )
}

export default Field
